'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('bcmModule')
    .factory('biaBuOwnerService', ['$http', 'env', function ($http, env) {
        var baseUrl = environment.apiUrl + '/Pilot/api/BIAProfile';

        function returnData(response) {
            return response.data;
        }

        return {

            // Get BIA BU Owner Container
            getBIABUOwnerContainer: function (biaProfileId, biaBuOwnerId) {
                return $http
                        .get(baseUrl + '/' + biaProfileId + '/BIABUOwner/' + biaBuOwnerId + '/Container')
                        .then(function (response) { return response.data; })
            },

            // Create BIA BU Owner
            createBIABuOwner: function (biaProfileId, biaBuOwner) {
                return $http
                    .post(baseUrl + '/' + biaProfileId + '/BIABUOwner', biaBuOwner)
                    .then(function (response) { return response.data; })
            },

            // Delete BU Owner
            deleteBIABUOwner: function (biaProfileId, biabuOwnerId) {
                var reqUrl = baseUrl + '/' + biaProfileId + '/BIABUOwner/' + biabuOwnerId;

                return $http
                        .delete(reqUrl)
                        .then(function (response) { return response.data; })
            },

            // Send Email Reminder to Owner
            sendEmailReminderToOwner: function (biaProfileId, biaBuOwner) {
                var reqUrl = baseUrl + '/' + biaProfileId + '/BIABuOwner/' + biaBuOwner.BIABUOwnerID + '/SendReminder';
                var isDebug = env.isDev || undefined;

                return $http
                    .post(reqUrl, {isDebug: isDebug, BIABuOwner: biaBuOwner})
                    .then(returnData);
            },

            // Get BIA Profiles to Validate for BU Owner Head
            getBIAProfilesToValidateByBUOwnerHead: function () {
                return $http
                    .get(baseUrl + '/ToValidate/For/BUOwnerHead')
                    .then(returnData);
            },

            // Get BIA Profiles to Validate for BCC
            getBIAProfilesToValidateByBusinessContinuityCoordinator: function () {
                return $http
                    .get(baseUrl + '/ToValidate/For/BusinessContinuityCoordinator')
                    .then(returnData);
            },

            updateBusinessUnitByBusinessUnitHeadID: function (biaProfileId, biaBuOwner, businessUnitHeadID) {
	            return $http
                    .post(baseUrl + '/' + biaProfileId + '/BIABUOwner/' + biaBuOwner + '/Update/BusinessUnit/' + businessUnitHeadID)
                    .then(returnData);
            }
        };
    }]);
